export default "__VITE_ASSET__CEOVvNKw__"